import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../api';

export const getMonitoringDictionaries = createAsyncThunk(
    'errorLogs/getMonitoringDictionaries',
    async (data, { rejectWithValue }) => {
        try {
            const api = '/monitoring/events/dictionaries?XDEBUG_SESSION_START=MyVSCode';
            const response = await apiInstance.post(api, JSON.stringify({ data }));
            
            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getMonitoringEvents = createAsyncThunk(
    'errorLogs/getMonitoringEvents',
    async (data, { rejectWithValue }) => {
        try {
            const api = '/monitoring/events/get?XDEBUG_SESSION_START=MyVSCode';
            const response = await apiInstance.post(api, JSON.stringify({ data }));
            
            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const createMonitoringEvent = createAsyncThunk(
    'errorLogs/createMonitoringEvent',
    async (data, { rejectWithValue }) => {
        try {
            const api = '/monitoring/events/create?XDEBUG_SESSION_START=MyVSCode';
            const response = await apiInstance.post(api, JSON.stringify({ data }));
            
            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    getMonitoringDictionariesStatus: null,
    getMonitoringEventsStatus: null,
    createMonitoringEventStatus: null,

    monitoringDictionaries: null,
    monitoringEvents: null,
    currentPage: 1,
    pageSize: 20,
    total: 0,
};

const errorLogsSlice = createSlice({
    name: 'errorLogs',
    initialState,
    extraReducers: (builder) => {
        builder
        .addCase(PURGE, () => {
            return initialState;
        })
        
        // Get Monitoring Dictionaries
        .addCase(getMonitoringDictionaries.pending, (state) => {
            state.getMonitoringDictionariesStatus = 'pending';
        })
        .addCase(getMonitoringDictionaries.fulfilled, (state, action) => {
            state.getMonitoringDictionariesStatus = 'resolved';
            state.monitoringDictionaries = action.payload;
        })
        .addCase(getMonitoringDictionaries.rejected, (state) => {
            state.getMonitoringDictionariesStatus = 'rejected';
        })

        // Get Monitoring Events
        .addCase(getMonitoringEvents.pending, (state) => {
            state.getMonitoringEventsStatus = 'pending';
        })
        .addCase(getMonitoringEvents.fulfilled, (state, action) => {
            state.getMonitoringEventsStatus = 'resolved';
            state.monitoringEvents = action.payload.items;
            state.currentPage = action.payload.pagination.page;
            state.total = action.payload.pagination.total;
        })
        .addCase(getMonitoringEvents.rejected, (state) => {
            state.getMonitoringEventsStatus = 'rejected';
        })

        // Create Monitoring Event
        .addCase(createMonitoringEvent.pending, (state) => {
            state.createMonitoringEventStatus = 'pending';
        })
        .addCase(createMonitoringEvent.fulfilled, (state, action) => {
            state.createMonitoringEventStatus = 'resolved';
        })
        .addCase(createMonitoringEvent.rejected, (state) => {
            state.createMonitoringEventStatus = 'rejected';
        })
    },
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
    },
});

export const {
    setCurrentPage,
    setPageSize,
} = errorLogsSlice.actions;

export default errorLogsSlice.reducer;
